import React, { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { DataLoadingCard, PersistentDataGrid } from 'common';

import { useGetProductsQuery } from './productsEndpoints';

const Products = () => {
  const columns = [
    {
      field: 'active',
      headerName: 'Active',
      valueGetter: value => (value ? 'Y' : 'N'),
    },
    {
      field: 'blendCode',
      headerName: 'Blend Code',
      width: 200,
    },
    {
      field: 'locationId',
      headerName: 'Location Id',
      width: 200,
    },
    {
      field: 'locationName',
      headerName: 'Location Name',
      width: 200,
    },
    {
      field: 'productId',
      headerName: 'Product Id',
      width: 200,
    },
    {
      field: 'longName',
      headerName: 'Long Name',
      width: 450,
    },
    {
      field: 'pidxProd',
      headerName: 'PIDX Prod',
      width: 200,
    },
    {
      field: 'productType',
      headerName: 'Type',
      width: 200,
    },
    {
      field: 'proprietary',
      headerName: 'Proprietary',
      valueGetter: ({ value }) => {
        if (value === true) return 'Y';
        if (value === false) return 'N';
        return '-';
      },
      width: 200,
    },
  ];
  const [filters, setFilters] = useState({
    locationId: '',
    locationName: '',
    productId: '',
    productName: '',
  });
  const [params, setParams] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });

  const handleSearch = () => {
    setParams({ ...filters });
  };

  const clearSearch = () => {
    setFilters({
      locationId: '',
      locationName: '',
      productId: '',
      productName: '',
    });
    setParams({});
  };

  const { data: productsData = [], isFetching: isFetchingProducts = false } = useGetProductsQuery({
    ...paginationModel,
    ...params,
  });

  return (
    <div style={{ padding: 1, pb: 0, width: '100%' }}>
      <div
        style={{
          height: 'calc(100vh - 79px)',
          marginTop: '50px',
          padding: 30,
          pb: 0,
          width: '100%',
        }}
      >
        {isFetchingProducts ? (
          <Box
            sx={{
              p: theme => ({ lg: theme.spacing(4, 1, 1), xs: theme.spacing(9, 3, 4) }),
              textAlign: 'center',
            }}
          >
            <DataLoadingCard type="data" />
          </Box>
        ) : (
          <>
            <TextField
              label="Location Id"
              name="locationId"
              onChange={event => {
                setFilters({
                  ...filters,
                  locationId: event.target.value,
                });
              }}
              style={{ marginRight: 'Right' }}
              sx={{ m: '5px' }}
              value={filters.locationId}
            />
            <TextField
              label="Location Name"
              name="locationName"
              onChange={event => {
                setFilters({
                  ...filters,
                  locationName: event.target.value,
                });
              }}
              style={{ marginRight: 'Right' }}
              sx={{ m: '5px' }}
              value={filters.locationName}
            />
            <TextField
              label="Product Id"
              name="productId"
              onChange={event => {
                setFilters({
                  ...filters,
                  productId: event.target.value,
                });
              }}
              style={{ marginRight: 'Right' }}
              sx={{ m: '5px' }}
              value={filters.productId}
            />
            <TextField
              label="Long Name"
              name="productName"
              onChange={event => {
                setFilters({
                  ...filters,
                  productName: event.target.value,
                });
              }}
              style={{ marginRight: 'Right' }}
              sx={{ m: '5px' }}
              value={filters.productName}
            />
            <Button onClick={clearSearch} sx={{ m: '7px' }} variant="outlined">
              Clear
            </Button>
            <Button onClick={handleSearch} sx={{ m: '7px' }}>
              Search
            </Button>
            <PersistentDataGrid
              columns={columns}
              getRowId={row => `${row.id}-${row.locationId}-${row.productId}`}
              loading={isFetchingProducts}
              onPaginationModelChange={setPaginationModel}
              pagination
              paginationMode="server"
              paginationModel={paginationModel}
              persist={false}
              rowCount={productsData?.totalRecords}
              rows={productsData?.results}
              showFilterButton
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Products;
